import { type FunctionComponent } from 'react';
import { type IconProps } from '../types';
import { IconWrapper } from '../style';

export const Award: FunctionComponent<IconProps> = ({
  color,
  rotation,
  width = '24px',
  height = '24px',
  cursor,
}: IconProps) => (
  <IconWrapper width={width} height={height} cursor={cursor}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      transform={`rotate(${rotation ?? 0})`}
    >
      <g mask="url(#mask0_2027_7929)">
        <path
          d="M11.5 11.3047L9.78133 12.6015C9.69789 12.6588 9.61711 12.6602 9.53898 12.6055C9.46086 12.5508 9.43742 12.4791 9.46867 12.3905L10.1249 10.2812L8.35938 8.89062C8.28125 8.83328 8.26039 8.76164 8.2968 8.6757C8.33336 8.58977 8.39586 8.5468 8.4843 8.5468H10.6251L11.3125 6.40625C11.3438 6.31766 11.4063 6.27336 11.5 6.27336C11.5938 6.27336 11.6562 6.31766 11.6875 6.40625L12.3595 8.5468H14.5077C14.5963 8.5468 14.6602 8.58977 14.6992 8.6757C14.7383 8.76164 14.6406 8.89062 14.6406 8.89062L12.8671 10.2812L13.5079 12.3905C13.5391 12.4791 13.5183 12.5508 13.4453 12.6055C13.3723 12.6602 13.2942 12.6588 13.2109 12.6015L11.5 11.3047ZM11.5 19.8282L6.97656 21.3437C6.72656 21.4323 6.49086 21.3959 6.26945 21.2345C6.0482 21.0729 5.93758 20.862 5.93758 20.6016V14.5234C5.27086 13.8151 4.78125 13.0287 4.46875 12.1641C4.15625 11.2995 4 10.4114 4 9.5C4 7.38547 4.72133 5.6068 6.16398 4.16398C7.6068 2.72133 9.38547 2 11.5 2C13.6145 2 15.3932 2.72133 16.836 4.16398C18.2787 5.6068 19 7.38547 19 9.5C19 10.4114 18.8438 11.2995 18.5312 12.1641C18.2188 13.0287 17.7291 13.8151 17.0624 14.5234V20.6016C17.0624 20.862 16.9518 21.0729 16.7305 21.2345C16.5091 21.3959 16.2734 21.4323 16.0234 21.3437L11.5 19.8282ZM11.5 15.4374C13.1563 15.4374 14.5599 14.862 15.711 13.711C16.862 12.5599 17.4374 11.1562 17.4374 9.5C17.4374 7.84375 16.862 6.44008 15.711 5.28898C14.5599 4.13805 13.1563 3.56258 11.5 3.56258C9.84375 3.56258 8.44008 4.13805 7.28898 5.28898C6.13805 6.44008 5.56258 7.84375 5.56258 9.5C5.56258 11.1562 6.13805 12.5599 7.28898 13.711C8.44008 14.862 9.84375 15.4374 11.5 15.4374ZM7.49992 19.4452L11.5 18.2656L15.5001 19.4452V15.8047C14.901 16.2109 14.2565 16.5117 13.5665 16.707C12.8763 16.9023 12.1875 17 11.5 17C10.8125 17 10.1237 16.9023 9.43352 16.707C8.74352 16.5117 8.09898 16.2109 7.49992 15.8047V19.4452Z"
          fill={color ?? 'currentColor'}
          stroke="white"
          strokeWidth="0.3"
        />
      </g>
    </svg>
  </IconWrapper>
);

Award.displayName = 'Award';
